import _Popover from './Popover';
import { TdPopoverProps } from './type';

import './style';

export * from './type';
export type PopoverProps = TdPopoverProps;

export const Popover = _Popover;
export default Popover;
